import { NavLink, useLocation } from 'react-router-dom';
// mantine
import { Burger, Drawer, Divider, UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
// components
import { LogOut } from 'lucide-react';
import Logo from '@/components/Logo';
// icons
// utils
import { cn } from '@/utils';
import navItems from '@/constants/navigation.tsx';
import { useProfileQuery } from '@/services/customer/profile/profile.queries.ts';
import useAppStore from '@/store/app';
import { PATHS } from '@/constants';

interface MobileNavigationProps {
    className?: string;
}

const handleSignOut = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    useAppStore.getState().logout();
};

const MobileNavigation = ({ className }: MobileNavigationProps) => {
    const [isOpened, handlers] = useDisclosure();
    const location = useLocation();
    const isCreatePartnerPage = location.pathname.includes(PATHS.createPartner);

    const { data: profile } = useProfileQuery(!isCreatePartnerPage);

    const handleClose = () => {
        handlers.close();
    };

    const handleToggle = () => {
        handlers.toggle();
    };

    if (isCreatePartnerPage) {
        return;
    }
    return (
        <>
            <Burger
                aria-label="Toggle navigation"
                className={className}
                opened={isOpened}
                onClick={handleToggle}
            />
            <Drawer
                opened={isOpened}
                title={<Logo className="inline-flex" variant="icon" />}
                onClose={handleClose}
            >
                <div className="flex flex-col gap-4 pt-4">
                    {navItems.map(({ icon, idn, path, label }) => {
                        const supIcon =
                            idn === 'billing' && profile?.status === 'temporal'
                                ? '⚠️'
                                : undefined;
                        return (
                            <NavLink
                                end
                                className={({ isActive }) =>
                                    cn(
                                        'flex items-center gap-4 text-xl no-underline text-gray-6 hover:text-gray-7',
                                        {
                                            'text-gray-9': isActive
                                        }
                                    )
                                }
                                key={path}
                                to={path}
                            >
                                {icon} {label}{' '}
                                <span className="relative top-0.5">
                                    {supIcon}
                                </span>
                            </NavLink>
                        );
                    })}
                    <Divider className="my-4" />
                    <UnstyledButton
                        className="flex items-center gap-4 text-xl no-underline text-red-4 hover:text-red-6"
                        onClick={handleSignOut}
                    >
                        <LogOut />
                        Sign Out
                    </UnstyledButton>
                </div>
            </Drawer>
        </>
    );
};

export default MobileNavigation;
